module.exports = __webpack_public_path__ + "static/media/sql_icon_store.3d7329ec.png";